import { AdvisorFee, ClientAgreements } from '../../FirmTermsAcceptance/data';

export const mockAgreementsData: {
  firmName: string;
  platformFee: string;
  agreements: ClientAgreements;
} = {
  firmName: 'Example Advisor Firm',
  platformFee: '25',
  agreements: {
    clientAgreement: {
      url: 'https://www.betterment.com/resources/investment-advisory-agreement-and-disclosures/',
      token: 'mock-client-agreement-token-abc123',
    },
    advPart2bAgreement: {
      url: 'https://www.betterment.com/resources/form-adv-part-2b/',
      token: 'mock-adv-part-2b-token-xyz789',
    },
  },
};

export const mockSimpleAdvisoryFee: AdvisorFee = {
  rate: '75 bps',
};

export const mockTieredAdvisoryFee: AdvisorFee = {
  tiers: [
    { range: '$0 - $50,000', rate: '100 bps' },
    { range: '$50,000 - $100,000', rate: '75 bps' },
    { range: '$100,000 - $250,000', rate: '50 bps' },
    { range: '$250,000+', rate: '25 bps' },
  ],
};
